import style from "./style.scss";
import { mergeClasses } from "../../../../components/helpers";

const VoltageRangeDisplay = ({
  min,
  max,
  range,
  tooLow = false,
  tooHigh = false,
}) => {
  const {
    min: minBar,
    highestMin: minBarMax,
    max: maxBar,
    highestMin: maxBarMin,
  } = range;

  const toPercent = (value) => ((value - minBar) / (maxBar - minBar)) * 100;

  const adjustedMin = Math.min(Math.max(min, minBar), minBarMax);
  const adjustedMax = Math.max(Math.min(max, maxBar), maxBarMin);

  const dot1 = toPercent(adjustedMin);
  const dot2 = toPercent(adjustedMax);

  return (
    <div class={style.voltageRange}>
      <div class={style.header}>
        <div class={style.selection}>
          Third-party battery ({adjustedMin}V~{adjustedMax}V)
          <span class={style.questionMark} />
        </div>
        <div class={style.description}>
          Set the input voltage range of the power station.
        </div>
      </div>
      <div class={style.track}>
        <div class={style.labelTrack}>
          <div class={style.labelContainer} style={{ "--percent": `${dot1}%` }}>
            <div class={style.label}>{adjustedMin}V</div>
          </div>
          <div
            class={style.labelContainer}
            style={{ "--percent": `${100 - dot2}%` }}
          >
            <div class={style.label}>{adjustedMax}V</div>
          </div>
        </div>
        <div class={style.trackGroup}>
          <div class={style.barTrack}>
            <div
              class={style.highlight}
              style={{
                left: `${Math.min(dot1, dot2)}%`,
                width: `${Math.max(dot2 - dot1, dot1 - dot2)}%`,
              }}
            />
          </div>
          <div class={style.dotTrack}>
            <div
              class={mergeClasses([style.dot, tooLow ? style.error : null])}
              style={{ left: `${dot1}%` }}
            />
            <div
              class={mergeClasses([
                style.dot,
                tooLow ? style.error : null,
                tooHigh ? style.error : null,
              ])}
              style={{ right: `${100 - dot2}%` }}
            />
          </div>
        </div>
      </div>
      <div class={style.labels}>
        <span>{minBar}V</span>
        <span>{maxBar}V</span>
      </div>
    </div>
  );
};

export default VoltageRangeDisplay;
